
import { SaleConfig } from "@/models/dossier-configs/sale-config";
import Vue from "vue";
import AppTranslationEditModal from "@/components/common/TranslationEditModal.vue";

export default Vue.extend({
	data(){
		return {
			translatedDefaultCommentModal: false,
			translatedSubTotalModal: false,
			translateRequirementsModal: false
		};
	},
	props: {
		config: {
			type: Object as ()=>SaleConfig,
			required: true
		}
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
	},
	methods: {
		editDefaultCommentTranslations() {
			this.translatedDefaultCommentModal = true;
		},
		editSubTotalTranslations(){
			this.translatedSubTotalModal = true;
		},
		editRequirementTranslations() {
			this.translateRequirementsModal = true;
		},
	},
	components: {
		AppTranslationEditModal,
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
